import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Store from './Store';
import { Provider } from 'react-redux';

// Provide Redux store from top most parent so that all redux state variables can be accessible by all components

if (process.env.NODE_ENV === 'production') {
  // console.log = () => {}
  // console.error = () => {}
  // console.debug = () => {}
}

ReactDOM.render(
  <Provider store={Store}>
      <App/>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
